import {LocalDate} from '@js-joda/core';
import AppBar from '@material-ui/core/AppBar';
import Container from '@material-ui/core/Container';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {EmployeeSchedule, Project} from '@tracker/shared/src/Scheduling/Utils/EmployeeSchedulesCompiler';
import React from 'react';
import ProjectScheduleTable from './ProjectScheduleTable';

const useStyles = makeStyles(theme => ({
    menuButton: {
        marginRight: theme.spacing(2),
    },
    container: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
    },
}));

type Props = {
    project : Project | null;
    startDate : LocalDate;
    employeeSchedules : EmployeeSchedule[];
    onClose : () => void;
    currentWeek : LocalDate;
};

const ProjectSchedule : React.FC<Props> = ({project, startDate, employeeSchedules, onClose, currentWeek} : Props) => {
    const classes = useStyles();

    return (
        <Dialog fullScreen open={project !== null}>
            <AppBar position="sticky">
                <Toolbar>
                    <IconButton
                        color="inherit"
                        onClick={onClose}
                        edge="start"
                        className={classes.menuButton}
                    >
                        <ArrowBackIcon/>
                    </IconButton>
                    <Typography variant="h6">
                        Project Schedule
                    </Typography>
                </Toolbar>
            </AppBar>

            <Container className={classes.container}>
                <>
                    {project && (
                        <ProjectScheduleTable
                            project={project}
                            startDate={startDate}
                            employeeSchedules={employeeSchedules}
                            currentWeek={currentWeek.toString()}
                        />
                    )}
                </>
            </Container>
        </Dialog>
    );
};

export default ProjectSchedule;
